// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCIiQVqogPnJgnOMvI_cuzCfzEKc1dP83g",
  authDomain: "community-squares-766d6.firebaseapp.com",
  projectId: "community-squares-766d6",
  storageBucket: "community-squares-766d6.firebasestorage.app",
  messagingSenderId: "633815454078",
  appId: "1:633815454078:web:ee33a926aa275ed765232f",
  measurementId: "G-E2TMLT99MP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Storage
const db = getFirestore(app);
const storage = getStorage(app);

// Export so other files can use them
export { db, storage };
